/* ---------------------------------------------------------------------------
   ws-ambassador-signup.js — client-side validation for the ambassador form
   ---------------------------------------------------------------------------
   Progressive enhancement only. Every constraint here is also expressed in the
   markup (required, type=email), so with this file blocked the browser still
   refuses an incomplete form and Shopify still validates server-side. What this
   adds is the wording and the placement of the message.

   WHY NOT LEAVE IT TO THE BROWSER: native bubbles say "Please fill out this
   field" beside an input the user may have scrolled past, they vanish on blur,
   and they are announced inconsistently. These messages persist next to the
   field, are wired with aria-describedby, and carry an icon as well as colour
   so they do not depend on red being visible.

   Handles are stripped of a leading @ before submit, because the prefix box
   already shows one and "@@wellx" is what you get otherwise.
--------------------------------------------------------------------------- */

(() => {
  const ROOT = '.ws-ambassador';
  if (window.wsAmbassadorSignup) return;
  window.wsAmbassadorSignup = true;

  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const messageFor = (field) => {
    if (field.validity.valueMissing) {
      return field.type === 'checkbox'
        ? 'Please accept the terms to continue.'
        : 'This field is required.';
    }
    if (field.type === 'email' && !EMAIL.test(field.value.trim())) {
      return 'Enter an email address in the form name@example.com.';
    }
    return '';
  };

  const errorSlot = (field) => {
    const id = `${field.id}-error`;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('p');
      el.id = id;
      el.className = 'ws-ambassador__error';
      // After the prefix wrapper when there is one, so the message clears the
      // whole control rather than landing between the @ box and the input.
      const anchor = field.closest('.ws-ambassador__prefix') || field;
      anchor.insertAdjacentElement('afterend', el);
    }
    return el;
  };

  const clear = (field) => {
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
    const el = document.getElementById(`${field.id}-error`);
    if (el) el.remove();
  };

  const show = (field, message) => {
    const el = errorSlot(field);
    el.textContent = message;
    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', el.id);
  };

  const check = (field) => {
    const message = messageFor(field);
    if (message) {
      show(field, message);
      return false;
    }
    clear(field);
    return true;
  };

  document.querySelectorAll(`${ROOT} form`).forEach((form) => {
    const fields = Array.from(form.querySelectorAll('[required], input[type="email"]'));

    fields.forEach((field) => {
      // Validate on blur, not on every keystroke: telling someone their email
      // is wrong while they are still typing it is noise, not help.
      field.addEventListener('blur', () => check(field));
      field.addEventListener('input', () => {
        if (field.hasAttribute('aria-invalid')) check(field);
      });
      field.addEventListener('change', () => {
        if (field.type === 'checkbox') check(field);
      });
    });

    form.addEventListener('submit', (event) => {
      form.querySelectorAll('[data-ws-handle]').forEach((input) => {
        input.value = input.value.trim().replace(/^@+/, '');
      });

      const bad = fields.filter((field) => !check(field));
      if (bad.length === 0) return;

      event.preventDefault();
      bad[0].focus();
      bad[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
    });

    // The browser's own bubbles would duplicate the messages above.
    form.setAttribute('novalidate', '');
  });
})();
